import styled from 'styled-components';

import {
  AnchorStyled,
  font12,
  font14,
  PStyled,
} from 'approot/shared/styles/typography.style';
import { grey4, grey7 } from 'approot/shared/styles/colours.style';
import { TabsScrollable } from 'approot/shared/tabs/tabs.style';
import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';

export const AssignClassDetailsTabs = styled(TabsScrollable)`
  border-top: 1px solid ${grey4};
  padding: 0 ${rem(spacing16)};
`;

export const AssignClassSmall = styled(PStyled).attrs({
  colour: grey7,
  marginBottom: 0,
})`
  ${font12}
`;

export const AssignClassSmallLink = styled(AnchorStyled).attrs({
  $fontWeight: 'normal',
})`
  ${font14}
`;
